<template>
    <div v-if="!canRead" class="area-content-body">
        <div class="no-permission-message">
            Sie haben keine Berechtigung, die Baustellenordnung zu öffnen.
        </div>
    </div>

    <div v-else-if="$root.project" class="area-content-body projects-site-order">
        <div class="project-head" :class="{dirty:$root.isDirty}">
            <header-field-editor class="project-number-edit"
                                 :input-hint="'Projekt-Nr.'"
                                 v-model:data-source="$root.project.number"
                                 :allow-edit="false" />
            <div class="v-line"></div>
            <span class="headline">Baustellenordnung</span>
            <div>
                <span v-if="canGenerateDocument"
                      class="head-toolbar-button-compact"
                      @click="generateDocument"
                      title="Baustellenordnung erstellen">description</span>
            </div>
            <attachments-button />
        </div>

        <div class="projects-notice-preview">
            <image-viewer ref="siteOrderPreview"
                          :attachment="{assignment:$root.project._id,assignmentType:'project',name:'Baustellenordnung.docx'}"
                          allowedTypes="application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                          :allowDownload="true"
                          :allowUpload="false"
                          :disableDrop="true"
                          style="height:calc(100% - 10px);"></image-viewer>
        </div>
    </div>

    <div v-else class="area-content-body">
        Daten werden geladen...
    </div>
</template>

<script lang="js">
    import { defineComponent } from 'vue';
    import siteOrderApi from '../services/SiteOrderApi';
    import ImageViewer from '../components/image-viewer.vue';
    import attachmentApi from '../services/AttachmentApi';
    import notify from 'devextreme/ui/notify';
    import HeaderFieldEditor from '../components/header-field-editor.vue';
    import AttachmentsButton from '../components/project-attachments-button.vue';
    import meApi from '../services/MeApi';
    import AppPermissions from '../constants/AppPermissions';

    export default defineComponent({
        components: {
            ImageViewer,
            HeaderFieldEditor,
            AttachmentsButton
        },
        data() {
            return {
                loading: false
            };
        },
        computed: {
            canRead() {
                return meApi.hasPermissionSync(AppPermissions.ProjectsTabsOrder.Read);
            },
            canWrite() {
                return meApi.hasPermissionSync(AppPermissions.ProjectsTabsOrder.Write);
            },
            canGenerateDocument() {
                return this.canWrite && meApi.hasPermissionSync(AppPermissions.ProjectFolder.Write);
            }
        },
        async created() {
            if (!this.canRead)
                return;

            if (this.$root.project && this.$route.params.id == this.$root.project._id) {
                this.loading = false;
            } else {
                this.loading = true;
                this.$root.loadProject(this.$route.params.id);
                this.loading = false;
            }
        },
        methods: {
            async generateDocument() {
                if (!this.canGenerateDocument)
                    return;

                try {
                    let att = await siteOrderApi.generateDocument(this.$root.project._id);
                    await this.$refs.siteOrderPreview?.setAttachment(att);

                    this.$root.toast("Baustellenordnung", [{
                        icon: "download",
                        hint: "Baustellenordnung herunterladen",
                        onClick: async (t) => {
                            await attachmentApi.download(att._id);
                            t.remove();
                        }
                    }], 5000);
                } catch {
                    notify("Fehler beim Erstellen der Unterlage", "error");
                }
            }
        }
    });
</script>

<style>
    .projects-site-order {
        display: grid;
        grid-gap: 10px;
        grid-template-columns: minmax(0,1fr);
        grid-template-rows: max-content minmax(0,1fr);
    }

    .projects-notice .project-head {
        grid-template-columns: max-content max-content 1fr max-content;
    }

    .headline {
        font-size: 1.5rem;
        align-self: center;
        padding: 5px 15px;
    }

    .no-permission-message {
        padding: 20px;
        background-color: #2a2a2a;
    }
</style>